import { restApi } from '../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'

const logsSolicitacoesRepository = createRepository({
  path: 'logs-solicitacoes',
  restApi
})

export default logsSolicitacoesRepository
